import { Box, Button, Flex, Grid, Spinner, Text } from "@chakra-ui/react";
import { MdClose as RemoveIcon } from "react-icons/md";
import RecipeCard from "@/components/RecipeCard";
import { Recipe } from "@/types/recipe";

interface RecipesTabProps {
  recipes: Recipe[];
  onRecipeClick: (recipeId: string) => void;
  onRemoveRecipe: (recipeId: string) => void;
  isRemoving: boolean;
  isLoading?: boolean;
  twoColumnMax?: boolean;
}

export default function RecipesTab({
  recipes,
  onRecipeClick,
  onRemoveRecipe,
  isRemoving,
  isLoading = false,
  twoColumnMax,
}: RecipesTabProps) {
  if (isLoading) {
    return (
      <Flex justify="center" py={12}>
        <Spinner size="md" color="accent.secondary" />
      </Flex>
    );
  }

  if (!recipes || recipes.length === 0) {
    return (
      <Box textAlign="center" py={12}>
        <Text fontFamily="body" fontWeight="300" color="text.muted">
          Add some recipes to get started with your collection.
        </Text>
      </Box>
    );
  }

  return (
    <Grid
      templateColumns={
        twoColumnMax
          ? { base: "1fr", md: "repeat(2, 1fr)" }
          : { base: "1fr", md: "repeat(2, 1fr)", lg: "repeat(3, 1fr)" }
      }
      gap={4}
    >
      {recipes.map((recipe) => (
        <RecipeCard
          key={recipe.id}
          recipe={recipe}
          onRecipeClick={(recipeId) => {
            window.scrollTo({ top: 0, behavior: 'smooth' });
            onRecipeClick(recipeId);
          }}
          deleteButton={
            <Button
              aria-label="Remove from collection"
              size="xs"
              variant="ghost"
              color="text.muted"
              _hover={{ color: 'accent.emphasis', bg: 'transparent' }}
              _active={{ bg: 'transparent' }}
              onClick={(e) => {
                e.preventDefault();
                e.stopPropagation();
                onRemoveRecipe(recipe.id);
              }}
              loading={isRemoving}
              p={0}
              minW="auto"
            >
              <RemoveIcon size={16} />
            </Button>
          }
        />
      ))}
    </Grid>
  );
}
